import { createAppSelector } from '../../../app/hooks/store-hooks';
import { store, subscribeStoreWithSelector } from '../../../app/state/store';
import { AlertSoundType } from '../../../common/enums';
import sound1 from './sounds/alert-sound-1.mp3?url';
import sound2 from './sounds/alert-sound-2.mp3?url';
import sound3 from './sounds/alert-sound-3.mp3?url';

let audio: HTMLAudioElement | undefined;

const sounds: Record<AlertSoundType, string> = {
    [AlertSoundType.sound1]: sound1,
    [AlertSoundType.sound2]: sound2,
    [AlertSoundType.sound3]: sound3
};

const audioSelector = createAppSelector(
    [(state) => state.settings.alertSoundType, (state) => state.settings.alertSoundVolume],
    (type, volume) => ({ type, volume })
);

function updateSoundSettings(settings: { type: AlertSoundType; volume: number }) {
    audio = new Audio(sounds[settings.type]);
    audio.volume = settings.volume / 100;
}

updateSoundSettings(audioSelector(store.getState()));
subscribeStoreWithSelector(audioSelector, updateSoundSettings);

export function playSound() {
    audio?.play();
}

export function playTestSound(options: { type: AlertSoundType; volume: number }) {
    audio = new Audio(sounds[options.type]);
    audio.volume = options.volume / 100;
    audio.play();
}
